import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://8963c265c844bda34cae40baa365d618@o4508933085659136.ingest.us.sentry.io/4508997737971712"
});

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider } from "react-redux";
import { UserProvider } from "@/context";
import setupStore from "./store";
import { initUserPilot } from "./services/userpilot";
import { initAnalytics } from "./services/analytics";
import AppConfigProvider from "./appConfig";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";


const root = ReactDOM.createRoot(document.getElementById("root"));
const store = setupStore();
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

initUserPilot(process.env.REACT_APP_USERPILOT_KEY);
initAnalytics();

root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_SOCIAL_CLIENT_ID}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Provider store={store}>
          <UserProvider>
            <AppConfigProvider>
              <App />
            </AppConfigProvider>
          </UserProvider>
        </Provider>
      </BrowserRouter>
    </QueryClientProvider>
  </GoogleOAuthProvider>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
